import { render, staticRenderFns } from "./ImageUplaoder.vue?vue&type=template&id=22c48106&"
import script from "./ImageUplaoder.vue?vue&type=script&lang=js&"
export * from "./ImageUplaoder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports